/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ClientWorkspaceUserDto } from '../../models/client-workspace-user-dto';

export interface ClientWorkspaceUserControllerFindUserById$Params {

/**
 * 멤버 ID
 */
  userId: string;

/**
 * 고객사 ID
 */
  id: any;
}

export function clientWorkspaceUserControllerFindUserById(http: HttpClient, rootUrl: string, params: ClientWorkspaceUserControllerFindUserById$Params, context?: HttpContext): Observable<StrictHttpResponse<ClientWorkspaceUserDto>> {
  const rb = new RequestBuilder(rootUrl, clientWorkspaceUserControllerFindUserById.PATH, 'get');
  if (params) {
    rb.path('userId', params.userId, {});
    rb.path('id', params.id, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ClientWorkspaceUserDto>;
    })
  );
}

clientWorkspaceUserControllerFindUserById.PATH = '/api/clientWorkspaceUser/{id}/users/{userId}';
